module.exports = __webpack_public_path__ + "img/login-logo.e3c19395.png";